import { render, staticRenderFns } from "./SpellcheckerPhrase.vue?vue&type=template&id=07edb8be&scoped=true"
import script from "./SpellcheckerPhrase.vue?vue&type=script&lang=js"
export * from "./SpellcheckerPhrase.vue?vue&type=script&lang=js"
import style0 from "./SpellcheckerPhrase.vue?vue&type=style&index=0&id=07edb8be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07edb8be",
  null
  
)

export default component.exports